// Dependencias generales
import React from "react"
import { useEffect } from 'react'
import { Auth } from 'aws-amplify'
import ReactGA from "react-ga4"

import avatarHeliasSinSuscripcion from '../img/dark-theme/helias-avatar.png'
import avatarHelias from '../img/dark-theme/helias-avatar.png'
import avatarHeliasBasico from '../img/basic.png'
import avatarHeliasAvanzado from '../img/advanced.png'
import avatarHeliasPremium from '../img/premium.png'

const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const updateInstallationConfiguration = endpointHelias+"/Helias/V0/Configuration/updateInstallationConfiguration"
const postCheckReferralCode = endpointHelias+"/Helias/V0/UserAccount/postCheckReferralCode"

var initialConfigCommonJS = require("../js/initialConfigCommon.js")
var generalCommonJS = require("../js/generalCommon.js")
var stripeCommonJS = require("../js/stripeCommon.js")

// CONFIGURACIÓN
const UserAccount = () => {

  useEffect(() => {           

    cargaTotalInicialUserAccount()
    generalCommonJS.autocierrePrivacidadGoogle()

  }, []);

  function cargaTotalInicialUserAccount(){
    
    try{

      // Los datos básicos los cargo del localstorage
      var datosStripe = {}
                      
      if( (localStorage.getItem("stripeData") !== null) && (Object.keys(JSON.parse(localStorage.getItem("stripeData")).length > 0)) ){
        datosStripe = JSON.parse(localStorage.getItem("stripeData"))        
      } 

      {/*
      if(!localStorage.getItem("installationName").includes("INSTALADOR")){
        if( (datosStripe.status !== undefined) && (datosStripe.status !== "trialing") && (datosStripe.status !== "paused") ){
          document.getElementById("detailCampañaReferidos").className = document.getElementById("detailCampañaReferidos").className.replaceAll(" hidden", "")
        }
        else{
          document.getElementById("detailCampañaReferidos").className = document.getElementById("detailCampañaReferidos").className.replaceAll(" hidden", "") + " hidden"
        }
      }
      else{
        document.getElementById("detailCampañaReferidos").className = document.getElementById("detailCampañaReferidos").className.replaceAll(" hidden", "") + " hidden"
      }  
      */}
      
      if(datosStripe !== null){
        document.getElementById("nombrePlanSuscripcion").innerHTML = stripeCommonJS.obtenerNombrePlanDePago(datosStripe)
      }
      else{
        document.getElementById("nombrePlanSuscripcion").innerHTML = "Sin suscripción"
      }

    }
    catch(error){console.log(error)}

    cargarDatosUsuario()    
    incluirMostrarOcultarPwd()    
  }

  const incluirMostrarOcultarPwd = (event) => {
    var passwordFields = document.querySelectorAll('fieldset.password');
    var passwordWrapper1 = ""
    var passwordWrapper2 = ""
    var passwordWrapper3 = ""

    if(passwordFields[0] !== undefined){
      passwordWrapper1 = passwordFields[0].querySelector('.icon-wrapper');
      passwordWrapper1.onclick = function(event){
        togglePasswordVisibility(event,passwordWrapper1);
      }
    }

    if(passwordFields[1] !== undefined){
      passwordWrapper2 = passwordFields[1].querySelector('.icon-wrapper');
      passwordWrapper2.onclick = function(event){
        togglePasswordVisibility(event,passwordWrapper2);
      }
    }

    if(passwordFields[2] !== undefined){
      passwordWrapper3 = passwordFields[2].querySelector('.icon-wrapper');
      passwordWrapper3.onclick = function(event){
        togglePasswordVisibility(event,passwordWrapper3);
      }
    }
    
  }

  function togglePasswordVisibility(e,passwordWrapper) {
    
    var passwordField = passwordWrapper.querySelector('input');

    if(e.target === passwordWrapper) {
      if ( passwordField.type === "password" ) {
        passwordWrapper.classList.add('visible');
        passwordField.type = "text";
      } else{
        passwordWrapper.classList.remove('visible');
        passwordField.type = "password";
      }
    };
  };

  function cargarDatosUsuario(){

    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
  
    if (lastAuthUser !== null){  
      var userData = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".userData")        
      userData = JSON.parse(userData);
    
      for (var i = 0; i < userData.UserAttributes.length; i++) {
          if(userData.UserAttributes[i].Name === "name"){
            document.getElementById("nombreUsuario").value = userData.UserAttributes[i].Value            
          }
          else if(userData.UserAttributes[i].Name === "family_name"){
            document.getElementById("apellidosUsuario").value = userData.UserAttributes[i].Value            
          }
          else if(userData.UserAttributes[i].Name === "phone_number"){
            document.getElementById("numeroTelefono").value = userData.UserAttributes[i].Value            
          }
          else if(userData.UserAttributes[i].Name === "email"){
            document.getElementById("email").value = userData.UserAttributes[i].Value            
          }
      }

    }
    else{
      initialConfigCommonJS.gestionarRespuestaPeticionErronea("401")
    }

  }
  
  function actualizarEmailBBDD(){
    
    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")    
    var ongoingInstallationConfigurationID = localStorage.getItem("ongoingInstallationConfiguration")  

    if(ongoingInstallationConfigurationID === null){
      ongoingInstallationConfigurationID = localStorage.getItem("installationId")
    }
    
    //Preparo los datos necesarios para el json
    var emailing = "true"
    
    var jsonEmailing = {          
      "installationID": ongoingInstallationConfigurationID,
      "Emailing": emailing,
      "oldEmail": generalCommonJS.obtenerEmailUsuario(),
      "email": document.getElementById("email").value
    }
  
    var jsonGuardado = {
      "accountID": localStorage.getItem("accountID"),
      "installationID": ongoingInstallationConfigurationID,      
      "Messaging": jsonEmailing
    }

    console.log(jsonGuardado)
  
    // Guardo la información  
    var xhttp = new XMLHttpRequest();  
      xhttp.open("POST", updateInstallationConfiguration, true);        
      xhttp.setRequestHeader('Content-Type', "application/json");
      xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
      var data = JSON.stringify(jsonGuardado);
      xhttp.onreadystatechange = function() {
        
        if (this.readyState === 4 && this.status === 200) {
          var jsonRespuestaGuardado = JSON.parse(this.responseText)
          if(jsonRespuestaGuardado.statusCode === "403"){                   
            initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
          }
          else{          
            console.log("Datos de usuario actualizados correctamente")

            document.getElementById("loaderGeneralAplicacion").className="loader hidden"
            window.location.href = "/Logout"                       
            
          }
        }
  
        if (this.readyState === 4 && this.status !== 200) {                          
          initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)       
        }
      }
      xhttp.send(data);        
      
  }

  function modificarDatosUsuario(){

    document.getElementById("loaderGeneralAplicacion").className="loader overlay"
        
    updateUser()

    async function updateUser() {
      const user = await Auth.currentAuthenticatedUser();
      
      if(document.getElementById("numeroTelefono").value === ""){ 
        document.getElementById("numeroTelefono").value = " "
      }

      actualizarEmailBBDD()           

      try{      
        await Auth.updateUserAttributes(user, {
          'email': document.getElementById("email").value,
          'name': document.getElementById("nombreUsuario").value,
          'family_name': document.getElementById("apellidosUsuario").value,
          'phone_number': document.getElementById("numeroTelefono").value
        });  
        
        setTimeout(() => { 
          initialConfigCommonJS.mostrarMensajeInformativo("Datos modificados correctamente","positive")           
        }, 800);            
      }
      catch (error){
        initialConfigCommonJS.mostrarMensajeInformativo("Se produjo un error al modificar su información, por favor revise que los datos son correctos y vuelva a intentarlo.","negative")
      }

    }

    

  }

  function modificarContraseña(){

    console.log("Modifico contraseña de usuario")
    
    if(document.getElementById("campoContraseñaNueva1").value === document.getElementById("campoContraseñaNueva2").value){
      changePassword()
    }
    else{
      initialConfigCommonJS.mostrarMensajeInformativo("Los campos de la nueva contraseña no son iguales, revísalo y vuelve a intentarlo","negative")
    }    

    async function changePassword() {
      const user = await Auth.currentAuthenticatedUser();
      try{      
        await Auth.changePassword(user, document.getElementById("campoContraseñaActual").value, document.getElementById("campoContraseñaNueva1").value);             
        setTimeout(() => { initialConfigCommonJS.mostrarMensajeInformativo("Contraseña cambiada correctamente.","positive") }, 800);            
      }
      catch (error){
        initialConfigCommonJS.mostrarMensajeInformativo("Se produjo un error al modificar tu contraseña, por favor revisa que la contraseña actual es correcta y que cumple los requisitos.","negative")
      }

    }
  }

  function mostrarMensajeEliminarCuenta(){

    if(localStorage.getItem("installationName").includes("INSTALADOR")){
      document.getElementById("errorReportingButton").className += " delete"      
      initialConfigCommonJS.mostrarMensajeConfirmacionBorrado("delete","ELIMINACIÓN DE TU CUENTA", "<p>Borrar tu cuenta significa 'dejar de existir en HELIAS'. Esto conlleva la eliminación de todas tus configuraciones y datos asociados<strong style='color: red'> de forma definitiva y no se podrán volver a recuperar</strong>.</p> <p>&nbsp</p> <p>¿Confirmas que quieres eliminarla definitivamente?</p>", procesoEliminacionCuenta, initialConfigCommonJS.cerrarMensajeBorrado)          
    }
    else{ //Usuario
      document.getElementById("errorReportingButton").className += " delete"      
      initialConfigCommonJS.mostrarMensajeConfirmacionBorrado("delete","ELIMINACIÓN DE TU CUENTA", "<p>Borrar tu cuenta significa 'dejar de existir en HELIAS'. Esto conlleva la eliminación de todas tus instalaciones, configuraciones y datos asociados<strong style='color: red'> de forma definitiva y no se podrán volver a recuperar</strong>.</p> <p>&nbsp</p>  <p><strong>¿Confirmas que quieres eliminarla definitivamente?</strong></p>", procesoEliminacionCuenta, initialConfigCommonJS.cerrarMensajeBorrado)          
    }
   
  }

  function procesoEliminacionCuenta(){

    if(localStorage.getItem("installationName").includes("INSTALADOR")){
      //Instalador      
      console.log("Eliminando cuenta de instalador y cerrando sesión.")      
      initialConfigCommonJS.eliminarCuentaInstalador(ReactGA)                        
    }
    else{ //Usuario      
      console.log("Eliminando cuenta de usuario y cerrando sesión.")      
      initialConfigCommonJS.eliminarCuentaUsuario(ReactGA)                  
    }

  }

  function obtenerAvatarPlanDePago(){

    try{
      var idPlan = JSON.parse(localStorage.getItem("stripeData")).priceId

      var avatar = ""
          
      if(idPlan !== "N/A"){     
          
        if (idPlan === "PH-M"){ avatar = avatarHelias }
        else if( (idPlan === "PR-A") || (idPlan === "PR-M") ){ avatar = avatarHeliasPremium }
        else if( (idPlan === "PA-A") || (idPlan === "PA-M") ){ avatar = avatarHeliasAvanzado }        
        else if( (idPlan === "PB-A") || (idPlan === "PB-M") ){ avatar = avatarHeliasAvanzado }        
      }
      else{ avatar = avatarHeliasSinSuscripcion }
    }
    catch(error){
      console.log(error)
      avatar = avatarHeliasSinSuscripcion
    }
  
    return avatar
  
  }

  function comprobarSuscripcionExistente(){

    try{

      var datosStripe = {}
            
      if( (localStorage.getItem("stripeData") !== null) && (Object.keys(JSON.parse(localStorage.getItem("stripeData")).length > 0)) ){
        datosStripe = JSON.parse(localStorage.getItem("stripeData"))        
      } 

      var planActual = datosStripe.priceId
  
      if( (planActual.includes("PH")) ||(planActual.includes("PB")) || (planActual.includes("PA")) || (planActual.includes("PR")) ){
        return true
      }
      else{
        return false
      }

    }
    catch(error){
      console.log(error)
      return false
    }

  }

  function copiarCodigoReferido(){

    try {
      navigator.clipboard.writeText(localStorage.getItem("accountID"));      
      initialConfigCommonJS.mostrarMensajeInformativo("Código de referido copiado al portapapeles.","positive")
    } catch (err) {
      initialConfigCommonJS.mostrarMensajeInformativo("Hubo algún problema al copiar el código de referido.","negative")
    } 

  }

  function aplicarCodigoReferido(){

    var codigoReferidoQueInvita = document.getElementById("campoIntroducirReferido").value

    var datosStripe = {}
                      
    if( (localStorage.getItem("stripeData") !== null) && (Object.keys(JSON.parse(localStorage.getItem("stripeData")).length > 0)) ){
      datosStripe = JSON.parse(localStorage.getItem("stripeData"))        
    } 

    if( (datosStripe.status !== undefined) && (datosStripe.status !== "trialing") ){

      if(codigoReferidoQueInvita === ""){ //Usuario intenta introducir su propio código
        initialConfigCommonJS.mostrarMensajeInformativo("Introduce el código de referido que te invitó a Helias.","negative")
      }
      else if(codigoReferidoQueInvita === localStorage.getItem("accountID")){ //Usuario intenta introducir su propio código
        initialConfigCommonJS.mostrarMensajeInformativo("¿Intentando hacer trampas? 😂","negative")
      }
      else{ 

        var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
        var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")    

        document.getElementById("loaderGeneralAplicacion").className="loader"
        
        //Preparo los datos necesarios para el json
        
        var jsonPeticion = {
          "accountID": localStorage.getItem("accountID"),
          "installationID": localStorage.getItem("installationId"),
          "referralCode": document.getElementById("campoIntroducirReferido").value
        }
      
        // Guardo la información  
        var xhttp = new XMLHttpRequest();  
          xhttp.open("POST", postCheckReferralCode, true);        
          xhttp.setRequestHeader('Content-Type', "application/json");
          xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
          var data = JSON.stringify(jsonPeticion);
          xhttp.onreadystatechange = function() {
            
            if (this.readyState === 4 && this.status === 200) {

              var jsonRespuestaGuardado = JSON.parse(this.responseText)

              if(jsonRespuestaGuardado.statusCode === "403"){                   
                initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
              }
              else{          

                console.log("Datos de usuario actualizados correctamente")

                var texto = ""
                var tipoMensaje = "positive"

                if(jsonRespuestaGuardado["responseMessage"] === "OK"){
                  texto = "Código de referido aplicado correctamente."
                }
                else if(jsonRespuestaGuardado["responseMessage"] === "KO"){
                  tipoMensaje = "negative"
                  texto = "Se ha producido un error al aplicar el código, por favor vuelve a intentarlo pasados unos minutos."
                }
                else if(jsonRespuestaGuardado["responseMessage"] === "ALREADY_USED"){
                  tipoMensaje = "negative"
                  texto = "Este código de referido ya ha sido utilizado."
                }
                else if(jsonRespuestaGuardado["responseMessage"] === "NO_SUBSCRIPTION"){
                  tipoMensaje = "info"
                  texto = "La suscripción de la persona que te invitó ya no existe."
                }
                else if(jsonRespuestaGuardado["responseMessage"] === "NOT_ALLOWED_TESTING"){
                  tipoMensaje = "info"
                  texto = "No se pueden aplicar códigos de referidos durante los periodos de prueba, ya sea quien invita o invitado."
                }                
                else if(jsonRespuestaGuardado["responseMessage"] === "REFERRED_CODE_INVALID"){
                  tipoMensaje = "negative"
                  texto = "El código de referido es inválido."
                }  
                else{
                  texto = "Otro texto"
                }

                initialConfigCommonJS.mostrarMensajeInformativo(texto,tipoMensaje)

                document.getElementById("loaderGeneralAplicacion").className="loader hidden"              
                
              }
            }
      
            if (this.readyState === 4 && this.status !== 200) {                          
              initialConfigCommonJS.gestionarRespuestaPeticionErronea(this.status)       
            }
          }
          xhttp.send(data);        

      }

    }
    else{
      initialConfigCommonJS.mostrarMensajeInformativo("No se pueden aplicar códigos de referidos durante el periodo de prueba.","negative")
    }
  
  }


  return (
     
      <section id="sectionUserAccount" className="wrapper">
        
        <div className="content-wrapper">            

          <div className="description comment bubble" >        
            <h1 className="headline-03 no-helias horizontal"><span className="fill">Cuenta de usuario</span></h1>  
          </div>    

          { comprobarSuscripcionExistente() ? 
            <>                            
            <button id="aLinkPortal" className="selection icon-wrapper" onClick={ () => stripeCommonJS.linkPortalStripeUsuario() }>
              <figure className="vertical-center vertical">                
                <img id="imgAvatarSuscripcion" src={obtenerAvatarPlanDePago()} width="40" alt="Avatar"/>
              </figure>
              <div className="vertical">                        
                <span id="nombrePlanSuscripcion" className="size-l"></span>
                <span id="tituloSuscripcion" className="size-s clarification">Suscripción</span>                        
              </div>
            </button>
            </>                           
          :
            <></>
          }

          <details id="detailDatosUsuario" className="accordion">
            
            <summary className="title">
              <figure className="avatar size-m cyan"><span className="material-icon">person</span></figure>                          
              <span className="size-l">Datos de usuario</span>
            </summary>    

            <ul className="accordion-content vertical gap-04">        

              <form onSubmit={e => { e.preventDefault(); }} spellCheck="false" autoComplete="off" autoCorrect="off">

                <fieldset className="two-columns">

                  <fieldset className="text">
                    <label htmlFor="name">Nombre</label>
                    <input type="text" id="nombreUsuario" />
                  </fieldset>

                  <fieldset className="text">
                    <label htmlFor="name">Apellidos</label>
                    <input type="text" id="apellidosUsuario" />
                  </fieldset>
                  </fieldset>

                  <fieldset className="two-columns">
                  <fieldset className="text">
                    <label htmlFor="name">E-Mail</label>
                    <input type="text" id="email" />
                  </fieldset>

                  <fieldset className="text">
                    <label htmlFor="name">Teléfono</label>
                    <input type="text" id="numeroTelefono" />
                  </fieldset>

                </fieldset>    
              </form>

              <fieldset>
                <button id="botonContinuar" className="button primary full-width" onClick={() => modificarDatosUsuario()}>Modificar datos</button>
              </fieldset>

            </ul>  
          </details>    

          <details id="detailModificarContraseña" className="accordion" >
            
            <summary className="title">
              <figure className="avatar size-m cyan"><span className="material-icon">password</span></figure>                          
              <span className="size-l">Cambiar contraseña</span>              
            </summary>    

            <ul className="accordion-content vertical gap-04">        
              
              <form onSubmit={e => { e.preventDefault(); }} spellCheck="false" autoComplete="off" autoCorrect="off" >

                <fieldset className="password">
                  <label htmlFor="name">Contraseña actual</label>
                  <div id="divCampoContraseñaActual" className="icon-wrapper">
                    <input type="password" id="campoContraseñaActual" autoComplete="new-password"/>
                  </div>
                </fieldset>
                
                <div className="vertical gap-04">

                  <fieldset className="two-columns">                  
                    <fieldset className="password">
                      <label htmlFor="name">Nueva contraseña</label>
                      <div id="divCampoContraseñaNueva1" className="icon-wrapper">
                        <input type="password" id="campoContraseñaNueva1" autoComplete="new-password"/>
                      </div>
                    </fieldset>                                  
                    <fieldset id="fieldsetCampoContraseñaNueva2" className="password">
                      <label htmlFor="name">Repite la nueva contraseña</label>
                      <div id="divCampoContraseñaNueva2" className="icon-wrapper">
                        <input type="password" id="campoContraseñaNueva2" autoComplete="new-password"/>
                      </div>
                    </fieldset>
                  </fieldset>    

                  <fieldset className="message info left" >                  
                    <h1><span className="material-icon">error</span>La nueva contraseña debe contener:</h1>
                    <ul className="default-list">
                      <li className="success size-xl">Al menos 1 número</li>                
                      <li className="success size-xl">Al menos 1 carácter especial</li>
                      <li className="success size-xl">Al menos una letra mayúscula</li>                
                      <li className="success size-xl">Al menos una letra minúscula</li>
                    </ul>                  
                  </fieldset>

                </div>

              </form>

              <fieldset>
                <button id="botonContinuar" className="button primary  full-width" onClick={() => modificarContraseña()}>Cambiar contraseña</button>
              </fieldset>

            </ul>  
          </details>
          
          {/*
          <details id="detailCampañaReferidos" className="accordion" >
            
            <summary className="title">
              <figure className="avatar size-m gold"><span className="material-icon">group_add</span></figure>                          
              <span className="size-l">Programa de referidos</span>              
            </summary>    

            <fieldset>
              
              <p><strong>Invita a gente a Helias y gana meses gratis</strong>. Por cada persona a la que le compartas tu código de referido y lo aplique tras la prueba gratuita recibirás 1 mes gratis. ¡Sin límite!.</p>
              
              <div className="message info left">
                <h1><span className="material-icon">code</span>Tu código de referido:</h1>   
                <p id="referralCode" className="link" style={{wordBreak: "break-all", color: "white"}} onClick={ () => copiarCodigoReferido()}>{localStorage.getItem("accountID")} <span className="material-icon" style={{color: "aqua"}}>copy</span></p>                
              </div>
            
              <div className="vertical gap-04">
                <fieldset className="message info left" >                  
                  <h1><span className="material-icon">terminal</span>¿Te han invitado?</h1>    
                  <fieldset>                  
                    <div className="icon-wrapper">
                      <input type="text" id="campoIntroducirReferido" placeholder="Introduce aquí el código..." />
                    </div>
                  </fieldset>
                  <button id="botonAplicarCodigoReferido" className="button primary  full-width" onClick={() => aplicarCodigoReferido()}>Aplicar código</button>
                </fieldset>
              </div>
            </fieldset>

            
          </details>
          */}

          <fieldset>
            <button id="botonContinuar" className="button secondary delete full-width" onClick={() => mostrarMensajeEliminarCuenta()}>Eliminar cuenta</button>
          </fieldset>

        </div>

      </section>      
    
  )
}

export default UserAccount